import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { SORT_DIRECTION } from "../../../utils/vars";

export const RULES_PAGE_REDUCER_NAME = "rules";

const initialState = {
  page: 0,
  take: 20,
  totalCount: 0,
  sort: {
    direction: SORT_DIRECTION.DESC,
    type: "DATE",
  },
  data: [],
  filters: {
    author: "",
    ruleName: "",
    typeOfRule: "",
    status: "",
    q: "",
    startDate: "",
    endDate: "",
    exactDate: "",
  },
};

const rulesSlice = createSlice({
  name: RULES_PAGE_REDUCER_NAME,
  initialState,
  reducers: {
    setRulesData: (state, { payload }) => {
      state.data = [...payload];
    },
    setRulesPage: (state, { payload }) => {
      state.page = payload;
    },
    setRulesTake: (state, { payload }) => {
      state.take = payload;
    },
    setRulesTotalCount: (state, { payload }) => {
      state.totalCount = payload;
    },
    setRulesFilters: (state, { payload }) => {
      const temp = { ...state.filters };
      state.filters = { ...temp, ...payload };
    },
    setRulesSort: (state, { payload }) => {
      state.sort = payload;
    },
    clearRules: (state) => {
      state.page = initialState.page;
      state.take = initialState.take;
      state.totalCount = initialState.totalCount;
      state.sort = initialState.sort;
      state.data = initialState.data;
      state.filters = initialState.filters;
    },
  },
});

export const {
  clearRules,
  setRulesData,
  setRulesPage,
  setRulesTake,
  setRulesTotalCount,
  setRulesFilters,
  setRulesSort,
} = rulesSlice.actions;

export default rulesSlice.reducer;

export const useSelectPageRules = () => {
  return useSelector((state) => state[RULES_PAGE_REDUCER_NAME].page);
};

export const useSelectTakeRules = () => {
  return useSelector((state) => state[RULES_PAGE_REDUCER_NAME].take);
};

export const useSelectRulesData = () => {
  return useSelector((state) => state[RULES_PAGE_REDUCER_NAME].data);
};

export const useSelectTotalCountRules = () => {
  return useSelector((state) => state[RULES_PAGE_REDUCER_NAME].totalCount);
};

export const useSelectFiltersRules = () => {
  return useSelector((state) => state[RULES_PAGE_REDUCER_NAME].filters);
};

export const useSelectSortRules = () => {
  return useSelector((state) => state[RULES_PAGE_REDUCER_NAME].sort);
};
